var _path, _stop, _stop2, _stop3, _stop4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";

function SvgOverview(props) {
  var _id2 = useUniqueInlineId();

  var _id = useUniqueInlineId();

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.697 4.66c1.86 0 3.367 1.584 3.367 3.538 0 1.953-1.506 3.537-3.365 3.538-1.859-.002-3.365-1.585-3.367-3.538h-.002c0-1.954 1.508-3.539 3.367-3.539z",
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.132 3H5.394a.406.406 0 00-.252.144l-.124.118A1.222 1.222 0 005 3.459c0 .78.83.857.83.857.48.12.808.58.784 1.096 0 .094-.01.188-.029.28a1.136 1.136 0 00-.114.48c0 .614.656.823.656.823.357.173.584.548.58.96 0 .19-.039.378-.112.552a1.02 1.02 0 00-.218.6c0 .505.507.792.507.792.245.198.39.503.395.827-.007.27-.09.53-.24.75a.905.905 0 00-.352.689c.022.284.148.548.352.737.154.194.241.437.247.69a1.312 1.312 0 01-.4.896.834.834 0 00-.496.75c.01.233.086.456.218.642.079.165.121.346.125.53 0 .644-.593.986-.593.986-.524.166-.655.517-.655.814.002.169.036.336.1.491.026.108.04.218.04.329 0 .808-.794 1.054-.794 1.054-.709.049-.831.559-.831.88 0 .082.007.164.022.244l.111.106c.074.072.166.119.265.135h8.736c2.758.01 5.001-2.332 5.01-5.23.005-1.54-.633-3.003-1.745-4.004 2.086-1.893 2.317-5.205.515-7.398C16.966 3.663 15.588 3 14.136 3h-.004zm.301 1.571c1.86 0 3.367 1.584 3.367 3.539 0 1.953-1.506 3.536-3.365 3.538-1.859-.002-3.365-1.585-3.366-3.538h-.003c0-1.955 1.508-3.539 3.367-3.539z",
    fill: "url(#".concat(_id2, ")")
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.685 8.083c0-.637-.5-1.153-1.116-1.153-.208 0-.402.058-.568.16a.43.43 0 01.138.317.42.42 0 01-.412.426.401.401 0 01-.23-.072c-.03.102-.045.21-.045.322 0 .637.5 1.153 1.117 1.153s1.116-.516 1.116-1.153z",
    fill: "#1D1D1B"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 19.776,
    y1: 6.438,
    x2: 16.258,
    y2: 3.015,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF7FE"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFFFF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 5.138,
    y1: 2.844,
    x2: 5.138,
    y2: 21.035,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A7FD"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4600DB"
  })))));
}

export default SvgOverview;